import * as React from "react";

function SvgRightArrow(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" width={9.614} height={14.43} {...props}>
        <path
          d="M.822 14.429a.831.831 0 00.515-.181l7.97-6.411a.822.822 0 00.307-.641.819.819 0 00-.307-.639L1.371.181A.821.821 0 00.216.307a.821.821 0 00.127 1.154l7.138 5.737-7.174 5.77a.821.821 0 00-.126 1.155.824.824 0 00.641.306z"
          fill="rgba(0,0,0,0.65)"
        />
      </svg>
    </span>
  );
}

export default SvgRightArrow;
